import { Maximize2, Minimize2, X } from "lucide-react";
import { Zap } from "react-feather";

function ChatBotHeader({
  expanded,
  onExpand,
  onClose,
}: {
  expanded: boolean;
  onExpand: () => void;
  onClose?: () => void;
}) {
  return (
    <div className="flex items-center justify-between bg-gradient-to-b from-gray-900 to-gray-800 border-b p-4">
      {/* <div className="flex items-center gap-2">
        <h2 className="flex items-center gap-2 justify-center text-sm font-semibold md:text-base text-white">
         <img src="/images/chat_bot.png" alt="chatbot" className="w-7 h-7" /> 
          <div className="h-10 w-10 rounded-full bg-gray-700"></div>
          <div className="h-2 w-2 rounded-full bg-green-500" aria-hidden />
          <span>Kazam Agent</span>
        </h2>
      </div> */}

      <div className="flex items-center gap-3">
        <div className="relative">
          <div className="h-10 w-10 rounded-full bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center shadow-lg">
            <span className="text-white font-bold text-lg">
              <Zap />
            </span>
          </div>
          <div className="absolute -bottom-1 -right-1 h-4 w-4 rounded-full bg-green-500 border-2 border-gray-900" />
        </div>
        <div>
          <h2 className="text-base font-semibold text-white">Kazam Agent</h2>
          <p className="text-xs text-green-500">Online</p>
        </div>
      </div>
      <div className="flex items-center gap-1">
        <button
          onClick={onExpand}
          className="inline-flex items-center gap-1 rounded-xl border border-gray-500 px-1.5 py-1 text-xs font-medium transition text-gray-300 "
          aria-label={
            expanded ? "Collapse to sidebar" : "Expand to full screen"
          }
          title={expanded ? "Collapse" : "Expand"}
        >
          {expanded ? (
            <>
              <Minimize2 className="h-3 w-3" />
            </>
          ) : (
            <>
              <Maximize2 className="h-3 w-3" />
            </>
          )}
        </button>
        {onClose && (
          <button
            onClick={onClose}
            className="inline-flex items-center gap-1 rounded-xl border border-gray-500 px-1.5 py-1 text-xs font-medium transition text-gray-300 "
            aria-label="Close chatbot"
            title="Close"
          >
            <X className="h-3.5 w-3.5" />
            {/* <span className="hidden sm:inline">Close</span> */}
          </button>
        )}
      </div>
    </div>
  );
}
export default ChatBotHeader;
